import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
import { jwtDecode } from 'jwt-decode';
import { Router } from '@angular/router';

@Component({
  selector: 'app-job-list',
  templateUrl: './job-list.component.html',
  styleUrls: ['./job-list.component.scss']
})
export class JobListComponent implements OnInit {
  organizations: any[] = [];
  allJobs: any[] = []; // Store all jobs
  jobs: any[] = []; // Jobs to display
  isLoadingFeaturedJobs: boolean = true; // Add this in your component class


  constructor(private apiService: ApiService, private router: Router) { }

  ngOnInit(): void {
    this.fetchOrganizations();
    this.fetchAllJobs();
  }

  fetchOrganizations(): void {
    this.apiService.getOrganizationsWithJobs().subscribe({
      next: (data) => {
        this.organizations = data;
      },
      error: (error) => console.error('Error fetching organizations:', error)
    });
  }

  fetchAllJobs(): void {
    this.isLoadingFeaturedJobs = true;
    this.apiService.getAllJobs().subscribe({
      next: (data) => {
        this.allJobs = data; // Store all jobs
        this.jobs = data; // Initialize displayed jobs
        this.isLoadingFeaturedJobs = false;
      },
      error: (error) => console.error('Error fetching jobs:', error)
    });
  }

  filterJobs(orgCode: string): void {
    if (orgCode === 'all') {
      // Navigate to the job list route
      this.router.navigateByUrl('/job-list');
    } else {
      // Assume orgCode is equivalent to organizationId for this example
      // You might need to adjust based on your actual data structure
      const selectedOrg = this.organizations.find(org => org.id === orgCode);
      if (selectedOrg) {
        this.router.navigateByUrl(`/organization/${selectedOrg.id}`);
      }
    }
  }

  isLoggedIn(): boolean {
    const token = localStorage.getItem('token');
    if (!token) {
      return false;
    }
    
    const decoded: any = jwtDecode(token);
    return decoded.exp > Date.now() / 1000;
  }
}
